/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureWorkloadCloudSummaryResponse {
    getFixupPrototypeFunction() { return TagPostureWorkloadCloudSummaryResponse.fixupPrototype; }

    static newInstance(model: Partial<TagPostureWorkloadCloudSummaryResponse>): TagPostureWorkloadCloudSummaryResponse {
        let obj = Object.assign(new TagPostureWorkloadCloudSummaryResponse(), model);
        TagPostureWorkloadCloudSummaryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureWorkloadCloudSummaryResponse>): TagPostureWorkloadCloudSummaryResponse {
        if (!model) return null;
        return TagPostureWorkloadCloudSummaryResponse.newInstance(<TagPostureWorkloadCloudSummaryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureWorkloadCloudSummaryResponse) {
        if (!obj) return;

        models.TagPostureWorkloadCloudSummaryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureWorkloadCloudSummaryResponse): boolean {
        Object.setPrototypeOf(obj, TagPostureWorkloadCloudSummaryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.TagPostureWorkloadCloudSummary.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.TagPostureWorkloadCloudSummary; };

}
